import React from 'react'
import { Menu } from 'antd'
import { Link } from 'react-router-dom'
import { Layout } from 'antd'
import CustomScrollbars from '../../util/CustomScrollbars'
import SidebarLogo from './SidebarLogo'
import {
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from '../../constants/ThemeSetting'
import IntlMessages from '../../util/IntlMessages'
import { useSelector } from 'react-redux'
import { footerText } from '../../util/config'
import { SIDEBAR_CONTENTS } from '../../constants/SideBarContents'
import { PERMISSION_GROUPS } from '../../constants/PermissionGroups'
import { usePermissionGroups } from '../../util/usePermissionGroups'
import { HK_REPORT_ROOT_PATH } from '../../util/reportForHkAccess'
const { Footer } = Layout
const SubMenu = Menu.SubMenu

const RESTRICTED_LINK_KEYS = [
  "main/dashboards",
  "hf",
  "acct",
  "master",
  "monthlyReport",
  "administration"
]

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings)
  const pathname = useSelector(({ common }) => common.pathname)
  const permissionGroups = usePermissionGroups()
  const isHkOnly = permissionGroups === PERMISSION_GROUPS.MLN_HK
  const isRestrict =
    permissionGroups !== PERMISSION_GROUPS.ADMINISTRATORS &&
    permissionGroups !== PERMISSION_GROUPS.OPERATOR &&
    permissionGroups !== PERMISSION_GROUPS.SENIOR_OPERATOR
  const sidebarContents = permissionGroups === undefined ? [] : SIDEBAR_CONTENTS

  const getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return 'gx-no-header-submenu-popup'
    }
    return ''
  }
  const selectedKeys = pathname.slice(1);
  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <div className="gx-sidebar-content">
        <CustomScrollbars className="gx-layout-sider-scrollbar gx-layout-sider-scrollbar-custome">
          <Menu
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline"
            defaultOpenKeys={[
              'hf',
              'acct',
              'master',
              'monthlyReport',
              'administration',
              'Analyze',
              'analyticalTool',
              'Historical',
              'OSBReport',
              HK_REPORT_ROOT_PATH.slice(1),
            ]}
          >
            {/*
                ADMINISTRATORS or OPERATOR or SENIOR_OPERATOR → all links
                USER_MANAGER, READER, ANALYST, SUPPORT → DataViewer and AnalyticalTools + HK
                MLN_HK → HK のみ
            */}
            {sidebarContents.map(content => {
              if (isHkOnly && content.key !== HK_REPORT_ROOT_PATH.slice(1)) {
                return null
              }
              if((RESTRICTED_LINK_KEYS.includes(content.key) &&  isRestrict)) {
                return null;
              }

              return (
                <React.Fragment key={content.key}>
                  {content?.items ? (
                    <SubMenu
                      key={`${content.key}`}
                      popupClassName={getNavStyleSubMenuClass(navStyle)}
                      title={
                        <span>
                          <i className={content.iconClassName} />
                          <span>
                            <IntlMessages id={content.intlMsgId} />
                          </span>
                        </span>
                      }
                    >
                      {content.items.map(item => (
                        <React.Fragment key={item.key}>
                          {item.children ? (
                            <SubMenu
                              key={item.key}
                              popupClassName={getNavStyleSubMenuClass(navStyle)}
                              title={
                                <span>
                                  <IntlMessages id={item.intlMsgId} />
                                </span>
                              }
                            >
                              {item.children.map(childItem => (
                                <Menu.Item key={childItem.key}>
                                  <Link to={childItem.linkTo}>
                                    <span>
                                      <IntlMessages id={childItem.intlMsgId} />
                                    </span>
                                  </Link>
                                </Menu.Item>
                              ))}
                            </SubMenu>
                          ) : (
                            <Menu.Item key={item.key}>
                              <Link to={item.linkTo}>
                                <span>
                                  <IntlMessages id={item.intlMsgId} />
                                </span>
                              </Link>
                            </Menu.Item>
                          )}
                        </React.Fragment>
                      ))}
                    </SubMenu>
                  ) : (
                    <Menu.Item key={content.key}>
                      <Link to={content.linkTo}>
                        <i className={content.iconClassName} />
                        <span>
                          <IntlMessages id={content.intlMsgId}/>
                        </span>
                      </Link>
                    </Menu.Item>
                  )}
                </React.Fragment>
              )
            })}
          </Menu>

          {!sidebarCollapsed && (
            <Footer className="custom-footer">
              <div className="gx-layout-footer-content">{footerText}</div>
            </Footer>
          )}
        </CustomScrollbars>
      </div>
    </>
  )
}

export default React.memo(SidebarContent)
